"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_number_format_1 = require("react-number-format");
const Coinbalance_1 = __importDefault(require("./Coinbalance"));
const JupButton_1 = __importDefault(require("./JupButton"));
const TokenIcon_1 = __importDefault(require("./TokenIcon"));
const SwapContext_1 = require("src/contexts/SwapContext");
const WalletPassthroughProvider_1 = require("src/contexts/WalletPassthroughProvider");
const ChevronDownIcon_1 = __importDefault(require("src/icons/ChevronDownIcon"));
const WalletIcon_1 = __importDefault(require("src/icons/WalletIcon"));
const utils_1 = require("src/misc/utils");
const constants_1 = require("../constants");
const CoinBalanceUSD_1 = require("./CoinBalanceUSD");
const index_1 = __importDefault(require("./PriceInfo/index"));
const SwitchPairButton_1 = __importDefault(require("./SwitchPairButton"));
const decimal_js_1 = __importDefault(require("decimal.js"));
const cn_1 = require("src/misc/cn");
const constants_2 = require("src/types/constants");
const JupShield_1 = __importDefault(require("./JupShield"));
const ScreenProvider_1 = require("src/contexts/ScreenProvider");
const useBalances_1 = require("src/hooks/useBalances");
const useUltraSwapMutation_1 = require("src/queries/useUltraSwapMutation");
const SubmitButton_1 = require("./SubmitButton");
const FormInputContainer = ({ tokenInfo, onBalanceClick, title, pairSelectDisabled, onClickSelectPair, children, value }) => {
    return ((0, jsx_runtime_1.jsxs)("div", { className: (0, cn_1.cn)('border border-transparent bg-module rounded-xl transition-all', 'py-3 px-4 flex flex-col dark:text-primary-text  gap-y-2', 'group focus-within:border-primary/50 focus-within:shadow-swap-input-dark rounded-xl'), children: [(0, jsx_runtime_1.jsxs)("div", { className: "flex justify-between items-center text-xs text-primary-text", children: [(0, jsx_runtime_1.jsx)("div", { children: title }), tokenInfo && ((0, jsx_runtime_1.jsxs)("div", { className: (0, cn_1.cn)('flex  space-x-1 text-xs items-center text-primary-text/50 fill-current ', {
                            'cursor-pointer': onBalanceClick,
                        }), onClick: (e) => {
                            onBalanceClick === null || onBalanceClick === void 0 ? void 0 : onBalanceClick(e);
                        }, children: [(0, jsx_runtime_1.jsx)(WalletIcon_1.default, { width: 10, height: 10 }), (0, jsx_runtime_1.jsx)(Coinbalance_1.default, { mintAddress: tokenInfo.id, hideZeroBalance: false }), (0, jsx_runtime_1.jsx)("span", { children: tokenInfo.symbol })] }))] }), (0, jsx_runtime_1.jsxs)("div", { className: "flex", children: [(0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsxs)("button", { type: "button", className: (0, cn_1.cn)('py-2 px-3 rounded-lg flex items-center bg-interactive text-primary-text', {
                                    'hover:bg-interactive/80': !pairSelectDisabled,
                                }), disabled: pairSelectDisabled, onClick: onClickSelectPair, children: [(0, jsx_runtime_1.jsx)("div", { className: "h-5 w-5", children: (0, jsx_runtime_1.jsx)(TokenIcon_1.default, { info: tokenInfo, width: 20, height: 20 }) }), (0, jsx_runtime_1.jsx)("div", { className: "ml-4 mr-2 font-semibold", translate: "no", children: (0, jsx_runtime_1.jsx)("div", { className: "truncate", children: tokenInfo === null || tokenInfo === void 0 ? void 0 : tokenInfo.symbol }) }), pairSelectDisabled ? null : ((0, jsx_runtime_1.jsx)("span", { className: "text-primary-text/25 fill-current", children: (0, jsx_runtime_1.jsx)(ChevronDownIcon_1.default, {}) }))] }), (0, jsx_runtime_1.jsx)("div", { className: "flex justify-between items-center h-[20px]", children: (tokenInfo === null || tokenInfo === void 0 ? void 0 : tokenInfo.id) && (0, jsx_runtime_1.jsx)(JupShield_1.default, { tokenAddress: tokenInfo.id }) })] }), (0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col items-end justify-between w-full", children: [children, (0, jsx_runtime_1.jsx)("span", { className: "text-xs text-primary-text/50", children: tokenInfo && (0, jsx_runtime_1.jsx)(CoinBalanceUSD_1.CoinBalanceUSD, { tokenInfo: tokenInfo, amount: value }) })] })] })] }));
};
const Form = ({ setSelectPairSelector }) => {
    const { publicKey, wallet } = (0, WalletPassthroughProvider_1.useWalletPassThrough)();
    const { data: balances } = (0, useBalances_1.useBalances)();
    const { form, setForm, fromTokenInfo, toTokenInfo, quoteResponseMeta, formProps: { fixedAmount, swapMode, fixedMint }, loading, isToPairFocused, setTxStatus, setLastSwapResult, } = (0, SwapContext_1.useSwapContext)();
    const { setScreen } = (0, ScreenProvider_1.useScreenState)();
    const { mutateAsync: ultraSwapMutation } = (0, useUltraSwapMutation_1.useUltraSwapMutation)();
    const onSubmit = (0, react_1.useCallback)(() => __awaiter(void 0, void 0, void 0, function* () {
        if (!wallet || !wallet.adapter.publicKey || !quoteResponseMeta) {
            return null;
        }
        try {
            if (!fromTokenInfo)
                throw new Error('Missing fromTokenInfo');
            if (!toTokenInfo)
                throw new Error('Missing toTokenInfo');
            yield ultraSwapMutation({
                quoteResponseMeta,
                fromTokenInfo,
                toTokenInfo,
                setTxStatus,
                setLastSwapResult,
            });
        }
        catch (error) {
            console.log('Swap error', error);
        }
        finally {
            setScreen('Swapping');
        }
    }), [wallet, quoteResponseMeta, ultraSwapMutation, fromTokenInfo, toTokenInfo, setTxStatus, setLastSwapResult, setScreen]);
    const shouldDisabledFromSelector = (0, react_1.useMemo)(() => {
        if ((fromTokenInfo === null || fromTokenInfo === void 0 ? void 0 : fromTokenInfo.id) === fixedMint) {
            return true;
        }
        return false;
    }, [fixedMint, fromTokenInfo === null || fromTokenInfo === void 0 ? void 0 : fromTokenInfo.id]);
    const shouldDisabledToSelector = (0, react_1.useMemo)(() => {
        if ((toTokenInfo === null || toTokenInfo === void 0 ? void 0 : toTokenInfo.id) === fixedMint) {
            return true;
        }
        return false;
    }, [fixedMint, toTokenInfo === null || toTokenInfo === void 0 ? void 0 : toTokenInfo.id]);
    const walletPublicKey = (0, react_1.useMemo)(() => publicKey === null || publicKey === void 0 ? void 0 : publicKey.toString(), [publicKey]);
    const onChangeFromValue = ({ value }) => {
        if (value === '') {
            setForm((form) => (Object.assign(Object.assign({}, form), { fromValue: '', toValue: '' })));
            return;
        }
        if (value === '.') {
            setForm((form) => (Object.assign(Object.assign({}, form), { fromValue: '0.' })));
            return;
        }
        const isInvalid = Number.isNaN(value);
        if (isInvalid)
            return;
        setForm((form) => (Object.assign(Object.assign({}, form), { fromValue: value })));
    };
    const onChangeToValue = ({ value }) => {
        if (value === '') {
            setForm((form) => (Object.assign(Object.assign({}, form), { fromValue: '', toValue: '' })));
            return;
        }
        if (value === '.') {
            setForm((form) => (Object.assign(Object.assign({}, form), { toValue: '0.' })));
            return;
        }
        const isInvalid = Number.isNaN(value);
        if (isInvalid)
            return;
        setForm((form) => (Object.assign(Object.assign({}, form), { toValue: value })));
    };
    const balance = (0, react_1.useMemo)(() => {
        if (!(fromTokenInfo === null || fromTokenInfo === void 0 ? void 0 : fromTokenInfo.id))
            return null;
        if (!balances)
            return null;
        const accBalanceObj = balances[fromTokenInfo.id];
        if (!accBalanceObj)
            return null;
        return accBalanceObj.uiAmount.toString();
    }, [balances, fromTokenInfo === null || fromTokenInfo === void 0 ? void 0 : fromTokenInfo.id]);
    const onClickMax = (0, react_1.useCallback)((e) => {
        e.preventDefault();
        if (!balance)
            return;
        if ((fromTokenInfo === null || fromTokenInfo === void 0 ? void 0 : fromTokenInfo.id) === constants_1.WRAPPED_SOL_MINT.toBase58()) {
            setForm((prev) => (Object.assign(Object.assign({}, prev), { fromValue: new decimal_js_1.default(balance).gt(constants_1.MINIMUM_SOL_BALANCE)
                    ? new decimal_js_1.default(balance).minus(constants_1.MINIMUM_SOL_BALANCE).toFixed(9)
                    : '0' })));
        }
        else {
            setForm((prev) => (Object.assign(Object.assign({}, prev), { fromValue: balance })));
        }
    }, [balance, fromTokenInfo === null || fromTokenInfo === void 0 ? void 0 : fromTokenInfo.id, setForm]);
    const onClickSwitchPair = () => {
        setForm((prev) => (Object.assign(Object.assign({}, prev), { fromValue: '', toValue: '', fromMint: prev.toMint, toMint: prev.fromMint })));
    };
    const { inputAmountDisabled, outputAmountDisabled } = (0, react_1.useMemo)(() => {
        const result = { inputAmountDisabled: true, outputAmountDisabled: true };
        if (!fixedAmount) {
            if (swapMode === constants_2.SwapMode.ExactIn) {
                result.inputAmountDisabled = false;
            }
            else if (swapMode === constants_2.SwapMode.ExactOut) {
                result.outputAmountDisabled = false;
            }
            else {
                result.inputAmountDisabled = false;
                result.outputAmountDisabled = false;
            }
        }
        return result;
    }, [fixedAmount, swapMode]);
    const onClickSelectFromMint = (0, react_1.useCallback)(() => {
        if (shouldDisabledFromSelector)
            return;
        setSelectPairSelector('fromMint');
    }, [shouldDisabledFromSelector, setSelectPairSelector]);
    const onClickSelectToMint = (0, react_1.useCallback)(() => {
        if (shouldDisabledToSelector)
            return;
        setSelectPairSelector('toMint');
    }, [shouldDisabledToSelector, setSelectPairSelector]);
    const thousandSeparator = (0, react_1.useMemo)(() => (utils_1.detectedSeparator === ',' ? '.' : ','), []);
    // Allow empty input, and input lower than max limit
    const withValueLimit = (0, react_1.useCallback)(({ floatValue }) => !floatValue || floatValue <= constants_1.MAX_INPUT_LIMIT, []);
    const handleClick = (0, react_1.useCallback)((event) => {
        if (window.Jupiter.enableWalletPassthrough && window.Jupiter.onRequestConnectWallet) {
            window.Jupiter.onRequestConnectWallet();
        }
        else {
            setScreen('Wallet');
        }
    }, [setScreen]);
    return ((0, jsx_runtime_1.jsxs)("div", { className: "h-full flex flex-col items-center justify-center", children: [(0, jsx_runtime_1.jsx)("div", { className: "w-full mt-2 rounded-xl flex flex-col px-2", children: (0, jsx_runtime_1.jsxs)("div", { className: "flex-col", children: [(0, jsx_runtime_1.jsx)(FormInputContainer, { tokenInfo: fromTokenInfo, onBalanceClick: (e) => {
                                isToPairFocused.current = false;
                                onClickMax(e);
                            }, title: "Selling", pairSelectDisabled: shouldDisabledFromSelector, onClickSelectPair: onClickSelectFromMint, value: form.fromValue, children: (fromTokenInfo === null || fromTokenInfo === void 0 ? void 0 : fromTokenInfo.decimals) && ((0, jsx_runtime_1.jsx)(react_number_format_1.NumericFormat, { disabled: fixedAmount || swapMode === constants_2.SwapMode.ExactOut, value: typeof form.fromValue === 'undefined' ? '' : form.fromValue, decimalScale: fromTokenInfo.decimals, thousandSeparator: thousandSeparator, allowNegative: false, valueIsNumericString: true, inputMode: "decimal", onValueChange: onChangeFromValue, placeholder: '0.00', className: (0, cn_1.cn)('w-full h-[40px] bg-transparent text-primary-text text-right font-semibold text-xl placeholder:text-primary-text/50', {
                                    'cursor-not-allowed': inputAmountDisabled || swapMode === constants_2.SwapMode.ExactOut,
                                }), onKeyDown: () => {
                                    isToPairFocused.current = false;
                                }, decimalSeparator: utils_1.detectedSeparator, isAllowed: withValueLimit })) }), (0, jsx_runtime_1.jsx)("div", { className: "relative z-10 -my-3 flex justify-center", children: (0, jsx_runtime_1.jsx)(SwitchPairButton_1.default, { onClick: onClickSwitchPair, className: (0, cn_1.cn)('transition-all') }) }), (0, jsx_runtime_1.jsx)(FormInputContainer, { tokenInfo: toTokenInfo, title: "Buying", pairSelectDisabled: shouldDisabledToSelector, onClickSelectPair: onClickSelectToMint, value: form.toValue, children: (toTokenInfo === null || toTokenInfo === void 0 ? void 0 : toTokenInfo.decimals) && ((0, jsx_runtime_1.jsx)(react_number_format_1.NumericFormat, { inputMode: "decimal", disabled: outputAmountDisabled || swapMode === constants_2.SwapMode.ExactIn, value: typeof form.toValue === 'undefined' ? '' : form.toValue, decimalScale: toTokenInfo.decimals, thousandSeparator: thousandSeparator, allowNegative: false, valueIsNumericString: true, onValueChange: onChangeToValue, className: (0, cn_1.cn)('h-[40px] w-full bg-transparent text-primary-text text-right font-semibold text-lg placeholder:text-primary-text/50', {
                                    'cursor-not-allowed': outputAmountDisabled || swapMode === constants_2.SwapMode.ExactIn,
                                }), placeholder: swapMode === constants_2.SwapMode.ExactOut ? 'Enter desired amount' : '0.00', decimalSeparator: utils_1.detectedSeparator, isAllowed: withValueLimit, onKeyDown: (e) => {
                                    if (e.metaKey ||
                                        e.ctrlKey ||
                                        e.key === 'Meta' ||
                                        e.key === 'Control' ||
                                        e.key === 'Alt' ||
                                        e.key === 'Shift') {
                                        return;
                                    }
                                    isToPairFocused.current = true;
                                } })) })] }) }), (0, jsx_runtime_1.jsxs)("div", { className: "w-full px-2", children: [!walletPublicKey ? ((0, jsx_runtime_1.jsx)(JupButton_1.default, { size: "lg", className: "w-full mt-4 bg-primary !text-uiv2-text/75", onClick: handleClick, children: "Connect Wallet" })) : ((0, jsx_runtime_1.jsx)(SubmitButton_1.SubmitButton, { onSubmit: onSubmit })), quoteResponseMeta && fromTokenInfo && toTokenInfo ? ((0, jsx_runtime_1.jsx)(index_1.default, { quoteResponse: quoteResponseMeta, fromTokenInfo: fromTokenInfo, toTokenInfo: toTokenInfo, loading: loading })) : null] })] }));
};
exports.default = Form;
